import moment from 'moment'

import { TripItem } from 'tripPlanner/types/tripItem'

export function getIsLuxPlusExclusiveAccess(item: TripItem): boolean {
  if ('savedItemData' in item && item.savedItemData) {
    if (item.savedItemData.isLuxPlusExclusive) return true

    const earlyAccessPeriod = item.savedItemData.luxPlusEarlyAccessPeriod
    if (earlyAccessPeriod) {
      const startDate = moment(earlyAccessPeriod.start)
      const endDate = moment(earlyAccessPeriod.end)
      const now = moment()

      return now.isBetween(startDate, endDate, 'second', '[]')
    }
  }

  return false
}
